<template>
  <div class="container mt-2">
    <!-- <h3 class="title is-4 has-text-centered mb-0">
      <span class="icon">
        <i class="fa fa-file-signature"></i>
      </span>
      {{ $t("account request") }}
    </h3> -->
    <p v-if="error" class="notification is-danger" v-html="error"></p>
    <!-- <Wizard v-if="request" :request="request" /> -->
  </div>
</template>

<script>
import { warning_message, get, generate_error_message_text } from "@/utils";
// import Wizard from "./complete/CreditRequestWizard.vue";

export default {
  name: "AccountRequestComplete",
  // components: { Wizard },
  data() {
    return {
      error: "",
      request: null,
    };
  },
  methods: {
    load_request(uuid) {
      get("/account-request/complete", { uuid: uuid })
        .then((response) => {
          this.request = response;
        })
        .catch((error) => {
          this.error = generate_error_message_text(error);
        });
    },
  },
  mounted() {
    let uuid = this.$route.params.uuid;
    if (uuid) this.load_request(uuid);
    else error = this.$t("invalid request id");
  },
};
</script>

<style scoped></style>
